export const STORES_CITIES_ACTIONS = {
  REQUESTED: 'stores/cities/requested',
  SUCCEEDED: 'stores/cities/succeeded',
  FAILED: 'stores/cities/failed',
};

export const STORES_ACTIONS = {
  REQUESTED: 'stores/requested',
  SUCCEEDED: 'stores/succeeded',
  FAILED: 'stores/failed',
};

export const REMOVE_STORE_ACTIONS = {
  REQUESTED: 'store/remove/requested',
  SUCCEEDED: 'store/remove/succeeded',
  FAILED: 'store/remove/failed',
};

export const EDIT_STORE_ACTIONS = {
  REQUESTED: 'store/edit/requested',
  SUCCEEDED: 'store/edit/succeeded',
  FAILED: 'store/edit/failed',
};

export const EDIT_ENTITY_ACTIONS = {
  REQUESTED: 'entity/edit/requested',
  SUCCEEDED: 'entity/edit/succeeded',
  FAILED: 'entity/edit/failed',
};

export const REMOVE_ENTITY_ACTIONS = {
  REQUESTED: 'entity/remove/requested',
  SUCCEEDED: 'entity/remove/succeeded',
  FAILED: 'entity/remove/failed',
};

export const CREATE_ENTITY_ACTIONS = {
  REQUESTED: 'create/entity/requested',
  SUCCEEDED: 'create/entity/succeeded',
  FAILED: 'create/entity/failed',
};

export const createEntityRequested = (entity: any) => ({
  type: CREATE_ENTITY_ACTIONS.REQUESTED,
  payload: { entity },
});

export const createEntitySucceeded = () => ({
  type: CREATE_ENTITY_ACTIONS.SUCCEEDED,
});

export const createEntityFailed = (error: any) => ({
  error,
  type: CREATE_ENTITY_ACTIONS.FAILED,
});

export interface CitiesRequested {
  type: string;
  countryId: string;
}

export const citiesRequested = (countryId: string): CitiesRequested => ({
  countryId,
  type: STORES_CITIES_ACTIONS.REQUESTED,
});

export interface CitiesSucceeded {
  type: string;
  payload: { regions: any[]; country: any };
}

export const citiesSucceeded = (
  regions: any[],
  country: any,
): CitiesSucceeded => ({
  type: STORES_CITIES_ACTIONS.SUCCEEDED,
  payload: { regions, country },
});

export interface CitiesFailed {
  type: string;
  error: string;
}

export const citiesFailed = (error: string): CitiesFailed => ({
  error,
  type: STORES_CITIES_ACTIONS.FAILED,
});

export interface StoresRequested {
  type: string;
  region: any;
}

export const storesRequested = (region: any): StoresRequested => ({
  region,
  type: STORES_ACTIONS.REQUESTED,
});

export interface StoresSucceeded {
  type: string;
  payload: { stores: any[] };
}

export const storesSucceeded = (stores: any[]): StoresSucceeded => ({
  type: STORES_ACTIONS.SUCCEEDED,
  payload: { stores },
});

export interface StoresFailed {
  type: string;
  error: string;
}

export const storesFailed = (error: string): StoresFailed => ({
  error,
  type: STORES_ACTIONS.FAILED,
});

export const removeStoreRequested = (storeId: string) => ({
  type: REMOVE_STORE_ACTIONS.REQUESTED,
  payload: { storeId },
});

export const removeStoreSucceeded = (storeId: string) => ({
  type: REMOVE_STORE_ACTIONS.SUCCEEDED,
  payload: { storeId },
});

export const removeStoreFailed = (error: string) => ({
  error,
  type: REMOVE_STORE_ACTIONS.FAILED,
});

export const editStoreRequested = (values: any) => ({
  type: EDIT_STORE_ACTIONS.REQUESTED,
  payload: { values },
});

export const editStoreSucceeded = () => ({
  type: EDIT_STORE_ACTIONS.SUCCEEDED,
});

export const editStoreFailed = (error: any) => ({
  error,
  type: EDIT_STORE_ACTIONS.FAILED,
});

export const editEntityRequested = (
  id: string,
  value: string,
  type: string,
) => ({
  type: EDIT_ENTITY_ACTIONS.REQUESTED,
  payload: { id, value, type },
});

export const editEntitySucceeded = () => ({
  type: EDIT_ENTITY_ACTIONS.SUCCEEDED,
});

export const editEntityFailed = (error: any) => ({
  error,
  type: EDIT_ENTITY_ACTIONS.FAILED,
});

export const removeEntityRequested = (id: string, type: string) => ({
  type: REMOVE_ENTITY_ACTIONS.REQUESTED,
  payload: { id, type },
});

export const removeEntitySucceeded = () => ({
  type: REMOVE_ENTITY_ACTIONS.SUCCEEDED,
});

export const removeEntityFailed = (error: any) => ({
  error,
  type: REMOVE_ENTITY_ACTIONS.FAILED,
});

export type StoresAction =
  | CitiesRequested
  | CitiesFailed
  | CitiesSucceeded
  | StoresRequested
  | StoresSucceeded
  | StoresFailed;



// WEBPACK FOOTER //
// ./src/scenes/Stores/services/actions.ts